"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMostRecentValidEmail_1 = require("./getMostRecentValidEmail");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return getMostRecentValidEmail_1.default; } });
//# sourceMappingURL=index.js.map